export class NewSkill {
    id: any = null;
    skill: any = '';
    category: any = '';
    alternateSkills: any = [];
    parentSkills: any = [];
    createdBy: any = null;
    lastModifiedBy: any = null;
}